
const PlayErrorBeep = (props) => {
    //console.log('PlayErrorBeep', props.type);
    switch (props.type) {
        case 'error':
            playToneSequence([
                { freq: 300, type: 'square', duration: 0.2, gain: 0.2 },
                { freq: 200, type: 'square', duration: 0.2, gain: 0.2 }
            ]);
            break;

        case 'warning':
            playToneSequence([
                { freq: 600, type: 'sine', duration: 0.2, gain: 0.3 },
                { freq: 700, type: 'sine', duration: 0.2, gain: 0.3 }
            ]);
            break;
    
        case 'success':
            playToneSequence([
                { freq: 880, type: 'triangle', duration: 0.1, gain: 0.1 }
            ]);
            break;

        default:
            break;
    }
    return null;
    
      
}


const playToneSequence = (sequence) => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    let time = ctx.currentTime;
  
    sequence.forEach(({ freq, type = 'sine', duration = 0.2, gain = 0.1 }) => {
      const osc = ctx.createOscillator();
      const vol = ctx.createGain();
  
      osc.type = type;
      osc.frequency.setValueAtTime(freq, time);
  
      vol.gain.setValueAtTime(gain, time);
      vol.gain.exponentialRampToValueAtTime(0.001, time + duration);
  
      osc.connect(vol);
      vol.connect(ctx.destination);
  
      osc.start(time);
      osc.stop(time + duration);
  
      time += duration + 0.05; // kleine Pause zwischen den Tönen
    });
  }



export default PlayErrorBeep;